import { motion } from 'framer-motion'
import React from 'react'
import './Team.css'
import { useSelector } from 'react-redux'

const Team = ({ data }) => {
  const { isDarkMode } = useSelector((state: any) => state.dark)

  const ceoData = data?.team?.find((item: any) => item?.isCeo)

  const otherMembersData = data?.team?.filter((item: any) => !item?.isCeo)

  return (
    <section className={`${isDarkMode ? 'bg-[#1c1c1c]' : 'bg-white'}`} id="team">
      <div className="mainContainer">
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          transition={{ duration: 1 }}
          variants={{
            visible: { opacity: 1 },
            hidden: { opacity: 0 }
          }}
          className="w-full px-5 pt-[40px]"
        >
          <p
            className={`inter main-title-back h-fit text-center  text-[60px] font-[900] ${
              isDarkMode ? ' text-[#252525]' : 'text-[#f3f3f3]'
            }  lg:text-[120px]`}
          >
            {data?.title}
          </p>
          <p
            className={`playfair main-title-front mt-[-60px] text-center text-[50px] font-[900] ${
              isDarkMode ? 'text-white' : 'text-[#121212]'
            }  lg:mt-[-140px] lg:text-[60px]`}
          >
            {data?.feature}
          </p>
          <p
            className={`inter services-desc mx-auto mt-8 mb-10 text-center text-[18px] ${
              isDarkMode ? 'text-[#bebebe]' : 'text-[#6e6e6e]'
            }  lg:mt-8 lg:mb-0 `}
          >
            {data?.description}
          </p>
        </motion.div>

        <motion.div className="mt-14 flex w-full justify-center">
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            transition={{ duration: 0.2 }}
            variants={{
              visible: { opacity: 1 },
              hidden: { opacity: 0 }
            }}
            className={`relative mt-[42px] flex max-h-[500px] w-full max-w-[404px] flex-col items-center justify-center rounded-[10px] ${
              isDarkMode ? 'bg-[#111]' : 'bg-[#f3f3f3]'
            }`}
          >
            <img
              src={`/images/Teams/${ceoData.img}`}
              alt={ceoData.img}
              className="mt-[-42px] h-[200px] w-[200px] rounded-[50%] "
            />
            <div className="team-card-info">
              <div
                className={`team-card-name playfair text-center text-[28px] font-black ${
                  isDarkMode ? 'text-white' : 'text-black'
                }`}
              >
                {ceoData.name}
              </div>
              <div
                className={`team-card-position inter text-center text-[17px] font-light ${
                  isDarkMode ? 'text-[#bebebe]' : 'text-[#6E6E6E]'
                }`}
              >
                {ceoData.position}
              </div>
            </div>
          </motion.div>
        </motion.div>

        <motion.div className="flex w-full justify-center">
          <div className="team-container ">
            {otherMembersData?.map((item, index) => (
              <motion.div
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                transition={{ duration: 0.2 }}
                variants={{
                  visible: { opacity: 1 },
                  hidden: { opacity: 0 }
                }}
                key={index}
                className={`team-card relative mt-[42px] ${
                  isDarkMode ? 'bg-[#111]' : 'bg-[#f3f3f3]'
                }`}
              >
                <img
                  src={`/images/Teams/${item.img}`}
                  alt={item.img}
                  className="mt-[-42px] h-[200px] w-[200px] rounded-[50%] "
                />
                <div className="team-card-info">
                  <div
                    className={`team-card-name playfair text-center text-[28px] font-black ${
                      isDarkMode ? 'text-white' : 'text-black'
                    }`}
                  >
                    {item.name}
                  </div>
                  <div
                    className={`team-card-position inter text-center text-[17px] font-light ${
                      isDarkMode ? 'text-[#bebebe]' : 'text-[#6E6E6E]'
                    }`}
                  >
                    {item.position}
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  )
}

export default Team
